/* Default prop types for VUE components */
export default {
  ARR: (def = [], required = false) => {
    return {
      type: Array,
      required,
      default() {
        return def;
      },
    };
  },
  OBJ: (def = {}, required = false) => {
    return {
      type: Object,
      required,
      default() {
        return def;
      },
    };
  },
  BOOL: (def = false, required = false) => {
    return {
      type: Boolean,
      required,
      default: def,
    };
  },
  STR: (def = '', required = false) => {
    return {
      type: String,
      required,
      default: def,
    };
  },
  NUM: (def = -1, required = false) => {
    return {
      type: Number,
      required,
      default: def,
    };
  },
  DATE: (def = null, required = false) => {
    return {
      type: Date,
      required,
      default: def,
    };
  },
};
